import React from "react";

import { useTheme } from "../../context/ThemeContext";
import ArrowRight from "../../images/icons/arrow-right.inline.svg";
import { getSourceImageUrlToCGI } from "../../utils/base";
import { Link } from "../../utils/customLink";
import { formatCurrencyAmount } from "../../utils/formatContent";

const BlogBanner = ({ post, scholarships }) => {
  const { currentSiteMeta } = useTheme();

  const bannerBgImage =
    getSourceImageUrlToCGI({
      uri: post?.blogIncontentBannerBgImage?.sourceUrl
    }) ?? "";
  const bannerText = post?.blogIncontentBannerText ?? "";
  const bannerButtonTitle = post?.blogIncontentBannerButtonTitle ?? "";
  const bannerButtonLink = post?.blogIncontentBannerButtonLink ?? "#";

  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";

  const exclusiveDiscount =
    scholarships?.find(
      (discount) => discount.exclusiveDiscountCurrency === currencyToUse
    ) ?? [];

  const scholarshipAmount = exclusiveDiscount?.exclusiveDiscountAmount ?? "";

  const scholarshipAmountDisplay = formatCurrencyAmount({
    currentSiteMeta,
    currency:
      currentSiteMeta?.currency ?? process.env.GATSBY_PROJECT_CURRENCY ?? "gbp",
    amount: scholarshipAmount
  });

  const promoBannerText = bannerText?.replace(
    "PROMO",
    scholarshipAmountDisplay
  );

  return (
    <div
      className="w-full py-10 bg-center bg-cover"
      style={{ backgroundImage: `url(${bannerBgImage})` }}
    >
      <div className="relative w-full mx-auto sm:w-11/12 planet:bg-gray-dark planet:bg-opacity-80 bg-white backdrop-blur-[50px] rounded-xs">
        <div className="flex items-center justify-around banner-content px-5 h-[100px]">
          <div>
            <h2
              className="font-light planet:text-white text-black-lighter pt-2"
              dangerouslySetInnerHTML={{ __html: promoBannerText }}
            />
          </div>
          <div className="px-5">
            <Link
              className="flex !justify-center sm:justify-between items-center w-full py-2 px-5 planet:px-4 text-mob planet:bg-green-standard bg-red-light sm:text-base font-bold !text-white planet:!text-gray-darker rounded-xxxxl planet:rounded-sm"
              to={bannerButtonLink}
            >
              {bannerButtonTitle}
              <span className="flex items-center pl-2">
                <ArrowRight className="stroke-white planet:stroke-gray-darker" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogBanner;
